'use client';

import { useState } from 'react';
import { Icon } from '@/app_components/common/Icon';
import { DescriptionParser } from '@/app_lib/htmlParser/DescriptionParser';
import { cn } from '@/app_lib/utils/utils';

type Props = {
  content: string;
};

export const AccordionDescription = ({ content }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='typography-sm pt-2 flex flex-col gap-1'>
      <div className={cn('overflow-hidden', { '@md:line-clamp-4 line-clamp-2': !isOpen })}>
        <DescriptionParser content={content} />
      </div>
      <button
        aria-label={isOpen ? 'Read Less' : 'Read More'}
        className='inline-flex cursor-pointer gap-2 items-center font-semibold text-accent'
        data-cy='accordion-description-toggle'
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (['Enter', ' '].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(!isOpen);
          }
        }}
        type='button'
      >
        <span className='uppercase'>Read {isOpen ? 'Less' : 'More'}</span>
        <Icon
          className={cn({ 'rotate-180 transform': isOpen })}
          icon='ButtonDown'
          size='sm'
        />
      </button>
    </div>
  );
};
